<template>
<body id="page-top" class="member-page-body loa-consult-new">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                <div class="row">
                <!-- EMAIL LOA -->
                <b-modal 
                        id="modal-prevent-closing"
                        ref="modal-email"
                        title="Send LOA to your email address"
                        ok-title-html="Send"
                        @show="resetModal"
                        @hidden="resetModal"
                        @ok="handleOk" 
                      >
                      <form ref="form-email" @submit.stop.prevent="handleEmailSubmit">
                        <b-form-group
                          label="Verify your email"
                          label-for="name-input"
                        >
                          <b-form-input
                            id="name-input"
                            v-model="previewEmail"
                            type="email"
                            :state="emailState"
                            @input="validateEmail"
                            required
                          ></b-form-input>
                        <b-form-invalid-feedback id="email-error">
                          {{ previewEmailFeedback }}
                        </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                          label="Retype your email"
                          label-for="email-verify-input"
                        >
                          <b-form-input
                            id="name-input"
                            v-model="verifyPreviewEmail"
                            type="email"
                            :state="verifyEmailState"
                            @input="validateVerifyEmail"
                          
                            required
                          ></b-form-input>
                          <b-form-invalid-feedback id="email-error">
                          {{ verifyEmailFeedback }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                      </form>
                    </b-modal>

                    <!-- Modal -->
                    <b-modal id="email-sent-modal" centered class="email-sent-modal" ref="email-sent-modal">
                      <p>{{ emailMessageReturn }}</p>  
                    </b-modal>
                    <!-- END EMAIL LOA -->
                    
               
                </div>

                <div class="row justify-content-center align-items-center loa-survey" v-if="showSurveyForm">
                    <div class="survey-form">
                      <SurveyForm @submit="handleFormSubmit" @closesurveyform="closeSurveyForm" />
                    </div>
                  </div>
               
                <div class="row justify-content-center"  v-if="step === 11">
                    <div>
                        <p class="h2 page-title">LOA for Consultation</p>
                    </div>
                </div>
                

                <!--STEPS (PAGE-2)-->
                <div v-if="step === 0 && !showSurveyForm" class="row align-items-start steps-row">
                    <div class="col loa-steps steps-active">
                      1
                    </div>
                    <div class="col loa-steps">
                      2
                    </div>
                    <div class="col loa-steps">
                      3
                    </div>
                    <div class="col loa-steps">
                      4
                    </div>
                </div>
                <!--STEPS (PAGE-3)-->
                <div v-if="step === 1 && !showSurveyForm" class="row align-items-start steps-row">
                    <div class="col loa-steps steps-done">
                      1
                    </div>
                    <div class="col loa-steps steps-active">
                      2
                    </div>
                    <div class="col loa-steps">
                      3
                    </div>
                    <div class="col loa-steps">
                      4
                    </div>
                    </div>
                <!--STEPS (PAGE-4)-->
                <div v-if="step === 3 && !showSurveyForm" class="row align-items-start steps-row">
                    <div class="col loa-steps steps-done">
                      1
                    </div>
                    <div class="col loa-steps steps-done">
                      2
                    </div>
                    <div class="col loa-steps steps-active">
                      3
                    </div>
                    <div class="col loa-steps">
                      4
                    </div>
                    </div>
                <!--STEPS (PAGE-5)-->
                <div v-if="step === 4 && !showSurveyForm" class="row align-items-start steps-row">
                    <div class="col loa-steps steps-done">
                      1
                    </div>
                    <div class="col loa-steps steps-done">
                      2
                    </div>
                    <div class="col loa-steps steps-done">
                      3
                    </div>
                    <div class="col loa-steps steps-done">
                      4
                    </div>
                    </div>
                <!--STEPS (PAGE-6)-->
                <div v-if="step === 5 && !showSurveyForm" class="row align-items-start steps-row">
                    <div class="col loa-steps steps-done">
                      1
                    </div>
                    <div class="col loa-steps steps-done">
                      2
                    </div>
                    <div class="col loa-steps steps-done">
                      3
                    </div>
                    <div class="col loa-steps steps-done">
                      4
                    </div>
                    </div>

          <section v-if="step === 0" class="page-section portfolio" id="portfolio">
            <div class="container">
                <div class="row justify-content-center loa-form">
                        <FindAProvider v-on:providercode="updateParentProvider" /> 
                </div>
            </div>
          </section>    
                <div v-if="step > 0 && !showSurveyForm" class="row justify-content-center loa-form">
                    <form autocomplete="off" @submit.prevent="handleSubmit">
                      
                    <div class="login-form">
                     
                      <div v-if="step === 2">
                        <p class="h4">IS THIS YOUR FIRST CONSULTATION WITH OUR DOCTOR?</p>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" v-model="loginType" value="firstCons">
                            <label class="form-check-label" for="flexRadioDefault1">
                              Yes, this is my first consultation.
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" v-model="loginType" value="followUp">
                            <label class="form-check-label" for="flexRadioDefault2">
                              No, this is my follow-up consultation.
                            </label>
                        </div>
                       </div>

                       <!--PAGE-2-->
                       <div v-if="(step === 1)" >
                    <p class="h4">WHO IS YOUR DOCTOR?</p>
                       
                       <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Doctor Name*</label>
                            <div class="col-sm-10">
                              <input autocomplete="off" v-b-modal.modal-center v-model="DoctorName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" required>
                            </div>
                            <div>
                        <!--<b-button style="float:right; margin-top:25px;" v-b-modal.modal-center type="button" class="btn btn-primary btn-lg">SEARCH</b-button>-->
                        

                        <b-modal id="modal-scrollable" ref="search-modal" scrollable title="List of Doctors:">
                            <div>
                            <a v-if="Doctors.length == 0" style="font-size:30px;">Please enter a Doctor Name.</a>
                            <a v-else-if="Doctors.length != 0" class="my-4 doctor-list" v-for="item in Doctors" :key="item.DoctorCode" @click="handleSelectItem(item)" > 
                            {{item.DoctorName}}<br>
                            {{item.Specialization}}<br>
                            {{item.TelNo}}
                            </a>
                            </div>
                        </b-modal>

                        <b-modal id="modal-center" ref="name-modal" content-class="customer-adv-modal" centered title="" @shown="focusFirstInput">
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Last Name</label>
                            <div class="col-sm-10">
                              <input ref="firstInput" autocomplete="off" v-model="LastName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                            </div>
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">First Name</label>
                            <div class="col-sm-10">
                              <input autocomplete="off" v-model="FirstName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                           </div>            
                           <b-button @click="searchDoctor" v-b-modal.modal-scrollable type="button" class="search-btn">Search</b-button>
                      </b-modal>
                        </div>
                       </div>
                    </div>
                          
                    <!--PAGE-3-->
                    <div v-if="step === 3 && loginType== 'followUp'">
                      <p class="h4">WHAT WAS YOUR DIAGNOSIS FROM THE DOCTOR?</p>
                        <div class="mb-3">
                            <label for="exampleFormControlTextarea1" class="form-label"></label>
                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" @focus="show" data-layout="normal" required></textarea>
                          </div>
                    </div>
                    <!--PAGE-4-->
                    <div style="text-align:center;" v-if="step === 4">
                      <iframe :src="LOAurl" crossorigin="anonymous" id="loaprint" ref="loaprint"></iframe>
                      <button  @click="print()" type="button" style="margin-right: 10px;" class="btn btn-primary btn-lg loa-print-btn" onClick="this.disabled=true " :disabled="LOAurl == ''">PRINT</button>
                      <b-button v-b-modal.modal-prevent-closing class="btn btn-secondary btn-lg email-pdf loa" :disabled="step == 1 || LOAurl == ''" >EMAIL LOA</b-button>
                    </div>
                    <!--<div v-if="step === 4">
                      <p class="lead custom-notice">
                                Your Letter of Authorization (LOA) for Consultation will be printed in two copies. You can get the printed copies in the printer below.<br>
                              </p>
                    </div>-->
                    <!--PAGE-5
                    <div v-if="step === 5">
                      <p class="lead custom-notice option-notice feedback-notice">
                                How Was Your Experience?
                               <a><img class="img-fluid" style="width:50%;" src="../assets/like.png" alt="..." /></a>
                              <a><img class="img-fluid" style="width:50%;" src="../assets/dislike.png" alt="..." /></a>
                              <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" @focus="show" data-layout="normal" required></textarea>
                            </p>
                    </div>-->

                      <div v-if="step === 5">
                      <p class="lead custom-notice option-notice">
                                Do you have other transactions?
                                <router-link to="/member-page"><button class="btn btn-primary btn-lg yes-no-option">YES</button></router-link>
                                <button class="btn btn-primary btn-lg yes-no-option" @click='logOut'>NO</button>
                            </p>
                    </div>

                    <div v-if="step === 3 && loginType== 'firstCons' ">
                      <p class="h4">HOW ARE YOU FEELING? WHAT IS YOUR CHIEF COMPLAINT?</p>
                        <div class="mb-3">
                            <label for="exampleFormControlTextarea1" class="form-label"></label>
                            <textarea v-model='ChiefComplaint' class="form-control" id="exampleFormControlTextarea1" rows="3" @focus="show" data-layout="normal" required></textarea>
                          </div>
                    </div>

                    <div>
                      <div>
                        <b-modal :no-close-on-backdrop="loading" :content-class="loading == true  ? 'customer-adv-modal processing-modal' : 'customer-adv-modal'"  centered title="" ref="my-modal" id="modal-center2">
                            <p class="my-4">{{returnMessage}}</p>
                            <button v-if="showreload == true" @click='reloadScreen' type="button" class="btn btn-primary btn-lg">OK</button>               
                        </b-modal>
                      </div>
                    </div>

                    </div>
                       <div class="col-md-12 member-custom-btn">
                  <router-link to="/member-page"><button style="float:left" class="btn btn-primary btn-lg">CANCEL</button></router-link>
                  <button @click='previousStep' type="button" class="btn btn-primary btn-lg" :disabled="step == 0">PREVIOUS</button>
                  <!--<button @click='nextStep' type='button' class="btn btn-primary btn-lg" :disabled="step == 5">NEXT</button>-->
                  <button class="btn btn-primary btn-lg" :disabled="step == 5">NEXT</button>
            </div>
            </form>
                  
                </div>
                </div>
        </section>
        
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
</body>
</template>

<script>
import FindAProvider from '../components/FindAProvider.vue'
import SurveyForm from "@/components/Survey.vue";
import axios from 'axios';
export default {
  name: 'PhilLogin',
  
  data() {
    return {
      loginType: 'firstCons',
      step: 0,
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      ChiefComplaint : '',
      DoctorName:'',
      DoctorCode:'',
      ServiceType:'CONSULTATION',
      FollowUp: 'N',
      CaseNo: '',
      LOAResponse:[],
      LOAurl:'',
      returnMessage:'',
      error:true,
      loading: false,
      showreload : false,
      visible: false,
      layout: "normal",
      input: null,
      options: {
      useKbEvents: false,
      preventClickEvent: false,
      ProviderCode : '',
      
    }, 
      previewEmail : '',
      verifyPreviewEmail : '',
      verifyEmailState : null,
      emailState : null,
      previewEmailFeedback : '',
      verifyEmailFeedback : '',
      showSurveyForm : false,
      emailMessageReturn : ''
    }
  },
  created() {
      //localStorage.removeItem('CertNo');
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  },
  methods: {
    async searchDoctor() {
     this.certNo = localStorage.getItem('CertNo')
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           LastName: this.LastName,
           ServiceType: 'CONSULT',
           ProviderCode: this.ProviderCode,
           CertNo: this.certNo
        }, 
        );

        console.log(response);
        this.Doctors=response.data
    },
    previousStep(){
      this.step = this.step-1
    },
    nextStep(){
      this.step = this.step+1
      if (this.step == 5) {
        this.showSurveyForm = true;
      }
      //console.log(this.step, this.loginType);
      //if (this.loginType=="firstCons" && this.step == 3){
       // this.handleSubmit()
      //}
    },

    print() {
    var iframe = document.getElementById("loaprint")
    iframe.contentWindow.focus();       
    iframe.contentWindow.print(); 
      },
    reloadScreen() {
      this.$refs['my-modal'].hide()
      this.step = this.step-1
    },
    async handleSubmit() {
      this.nextStep()
      console.log(this.step, this.loginType);
        if ((this.loginType=="firstCons" && this.step == 4) || (this.loginType=="followUp" && this.step == 4)){
          
          this.loading = true
          this.returnMessage = "We are processing your request now. Please wait..."
          this.error = false
          this.showModal()

          if(this.loginType=="firstCons"){
            this.FollowUp='N'
            this.ServiceType='CONSULTATION'
          } else {
            this.FollowUp='Y'
            this.ServiceType='PROCEDURE'
          }

          this.TokenID = localStorage.getItem('TokenID')
          this.certNo = localStorage.getItem('CertNo')
          try{
              const response = await axios.post('/api/?action=member-loa-consultation', {
                CertNo: this.certNo,
                DoctorCode: this.DoctorCode,
                FollowUp: this.FollowUp,
                ChiefComplaint: this.ChiefComplaint,
                ServiceType: this.ServiceType,
                ProviderCode: this.ProviderCode
              }, 
              );

        

                //const data = JSON.parse(response.data);
              //const responseO = '{"data":{"returnMessage":"Loa Created", "Message":"Successfully Created LOA", "SuccessFlag":"True", "LOAURL":"http://localhost:8080/philcare-kiosk/GenerateLOA.pdf"}}';
              //const response = JSON.parse(responseO);
                console.log("LOA",response);
    
                if (response.data.SuccessFlag) {
                  if (response.data.SuccessFlag == 'True'){
                      this.returnMessage = response.data.Message
                      //this.LOAResponse=response.data
                      this.CaseNo=response.data.CaseNo
                      this.LOAurl=response.data.LOAURL+"#toolbar=0" //"https://apps.philcare.com.ph//ITGPortalTest//GenerateLOA.aspx?CaseNo=202203070007#toolbar=0"
                      localStorage.setItem('LOAurl', this.LOAurl)
                      this.showModal()
                      this.loading = false
                  } else {
                      this.loading = false
                      this.returnMessage = response.data.Message
                      this.showModal()
                      console.log("returnmessage",this.returnMessage);
                  }
               }
        
                  //this.hideModal()
          }
         catch (error) {
            this.loading = false
            console.log(error.message);
            this.showreload = true;
            //this.returnMessage=error.message;
            this.returnMessage = "Something went wrong, \n Please click the reload button to generate the LOA again."
           // this.returnMessage=error.message;
            this.showModal()
        }
                    //this.$router.push('/loa-page-2');
                  } else {
                    //this.$router.push('/loa-cons-2');
                  }
                  
        
    },
    handleSelectItem(item){
      console.log(item);
      this.DoctorName = item.DoctorName
      this.DoctorCode = item.DoctorCode
      this.hideModal()
    },
    hideModal() {
            this.$refs['search-modal'].hide(),
            this.$refs['name-modal'].hide()
          },
    showModal() {
            this.$refs['my-modal'].show()
          },
    accept() {
          this.hide();
        },
    logOut() {
        localStorage.removeItem('CertNo');
        localStorage.removeItem('allowLOAConsult');
        localStorage.removeItem('allowLOALab');
        this.$router.push('/login');

    },
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        },
        updateParentProvider(value_from_child) {
          if (value_from_child != 0) {
              this.step = 1
              this.ProviderCode = value_from_child
          }
        },
    validateEmail() {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(this.previewEmail)) {
      this.emailState = true; // Valid email
      this.previewEmailFeedback = '';
    } else {
      this.emailState = false; // Invalid email
      this.previewEmailFeedback = 'Please enter a valid email address.';
    }
  },
  validateVerifyEmail() {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(this.verifyPreviewEmail)) {
      this.verifyEmailState = true; // Valid email
      this.verifyEmailFeedback = '';
    } else {
      this.verifyEmailState = false; // Invalid email
      this.verifyEmailFeedback = 'Please enter a valid email address.';
    }
  },
  resetModal() {
    this.verifyPreviewEmail = ''
    this.previewEmail = ''
    this.verifyEmailState = null
  },
  handleOk(bvModalEvent) {
    bvModalEvent.preventDefault()
    this.handleEmailSubmit()
  },

  async handleEmailSubmit() {
    this.emailState = true;
    if (this.previewEmail == '') {
      this.emailState = false; // Invalid email
      this.previewEmailFeedback = 'Please enter a valid email address.';
    }

    if (this.verifyPreviewEmail == '') {
      this.verifyEmailState = false;  // Invalid email
      this.emailState = false; 
      this.verifyEmailFeedback = 'Please enter a valid email address.';
    }

    if (this.verifyPreviewEmail != this.previewEmail ) {
      this.verifyEmailState = false; 
      this.emailState = false; // Invalid email
      this.verifyEmailFeedback = "`Email addresses don't match";
    }

    if (!this.emailState) { 
      return
    } 

   
    this.certNo = localStorage.getItem('CertNo');
    const response = await axios.post('/api/?action=email-loa-pdf', {
       Email : this.previewEmail,
       CaseNo: this.CaseNo
    }) 

    if (response.data[0].SuccessFlag == "1") {
      this.$bvModal.hide('modal-prevent-closing')
      this.$refs['email-sent-modal'].show();
      this.emailMessageReturn = 'LOA form has been successfully sent to your email!';
    }

   // this.emailMessageReturn = response.data.MessageReturn
    console.log(response)

    
  },
  focusFirstInput() {
      this.$refs.firstInput.focus();
  },
  
  async handleFormSubmit(answers) {
    console.log("Submitted answers:", answers);
    this.certNo = localStorage.getItem('CertNo');
    const response = await axios.post('/api/?action=submit-survey', {
       Answers : answers,
       Facility : this.ServiceType,
       CertNo: this.certNo,
       CaseNo: this.CaseNo
    }) 

    console.log(response)
  },

  closeSurveyForm(closeform) {
    this.showSurveyForm = closeform;
  }
  },
  components: {
    FindAProvider,
    SurveyForm
  }
  }




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
